import React from 'react';
import DataComponent from 'Core/components/DataComponent';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {getPageActions} from 'Core/helpers/redux';
import * as pageConfig from '../../config';
import {fetchSignalQualityReportsAction} from '../../actions';
import {get} from 'lodash';
import AdvancedDropdown, {ADVANCED_DROPDOWN_POSITION} from 'Core/components/display/AdvancedDropdown';
import Button, {BUTTON_DISPLAY_TYPE, BUTTON_STYLE} from 'Core/components/display/Button';
import {main_layout_element} from 'Config/app';
import {getArray, getString} from 'Core/helpers/data';
import Label from 'Core/components/display/Label';
import {getIOUrl} from 'Core/io/helper';
import {rtrimString} from 'Core/helpers/string';
import DownloadButton from 'Core/components/action/DownloadButton';

/**
 * Define all actions used by this component.
 */
const allActions = getPageActions({fetchSignalQualityReportsAction});

class MainTableSignalQualityReports extends DataComponent {
	constructor(props) {
		super(props, {
			/** @type {null|string[]|undefined} */
			data: null,
			/** @type {boolean} */
			dataLoading: false,
		}, {
			translationPath: pageConfig.translationPath,
			domPrefix: 'signal-quality-reports-dropdown',
			disableLoad: true,
			optimizedUpdate: true,
			optimizedUpdateIgnoreProps: ['onChange', 'onEnterKey', ...Object.keys(allActions)],
		});

		// Data methods
		this.loadReportList = this.loadReportList.bind(this);
		this.clearAllData = this.clearAllData.bind(this);
	}


	// Data methods -----------------------------------------------------------------------------------------------------
	/**
	 * Load the list of reports
	 *
	 * @return {Promise<Object>}
	 */
	loadReportList() {
		const {studyId, fetchSignalQualityReportsAction} = this.props;

		return this.setState({dataLoading: true})
			.then(() => this.executeAbortableAction(
				{id: 'fetch-signal-quality-reports',  action: fetchSignalQualityReportsAction},
				studyId
			))
			.then(response => this.setData(get(response, 'data')))
			.then(() => this.setState({dataLoading: false}));
	}

	/**
	 * Clear all component's relevant internal data
	 *
	 * @return {Promise<Object>}
	 */
	clearAllData() {
		// Abort fetching reports
		this.abortAction('fetch-signal-quality-reports');

		return this.clearData()
			.then(() => this.setState({dataLoading: false}));
	}


	// Render methods ---------------------------------------------------------------------------------------------------
	render() {
		const {studyId, disabled} = this.props;
		const {dataLoading} = this.state;
		const data = this.getData();
		const dataArray = getArray(data);

		return (
			<AdvancedDropdown
				className={this.getOption('domPrefix')}
				defaultPosition={ADVANCED_DROPDOWN_POSITION.LEFT}
				label={(
					<Button
						className="action-btn"
						displayStyle={disabled ? BUTTON_STYLE.SUBTLE : BUTTON_STYLE.ACTION}
						displayType={BUTTON_DISPLAY_TYPE.NONE}
						icon="chevron-down"
					/>
				)}
				parent={main_layout_element}
				boundRect={document.querySelector(`.layout-page`)?.getBoundingClientRect()}
				loading={dataLoading}
				contentClassName={`${this.getOption('domPrefix')}-content no-padding`}
				contentSize="0.8rem"
				onOpen={this.loadReportList}
				onClosed={this.clearAllData}
				disabled={disabled}
			>
				{data !== null ?
					<div className={`${this.getOption('domPrefix')}-item text-left`} data-group-label={true}>
						{dataArray.length > 0 ?
							dataArray.map(i =>
								<DownloadButton
									id={i}
									label={i}
									className={`${this.getOption('domPrefix')}-item`}
									displayStyle={BUTTON_DISPLAY_TYPE.NONE}
									url={getIOUrl('defaultAuthorizedApi', 'study/read-report')}
									filename={rtrimString(getString(i), '.enc2')}
									data={{
										id: studyId,
										file: i,
									}}
								/>
							)
							:
							<div className={`${this.getOption('domPrefix')}-item`} data-label={true}>
								<Label content={this.t('no_reports')} />
							</div>
						}
					</div>
					: null
				}
			</AdvancedDropdown>
		);
	}
}

/**
 * Define a component's own props that can be passed to it by parent components
 */
MainTableSignalQualityReports.propTypes = {
	studyId: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
};

export default connect(null, allActions, null, {forwardRef: true})(MainTableSignalQualityReports);